import { c as _c } from "react/compiler-runtime";
import { Image } from '@petsmart-ui/sparky';
import Link from 'next/link';
import { Text } from '../../../Text';
import type { NavCardProps } from '../types';
import './NavCard.scss';
export function NavCard(t0) {
  const $ = _c(15);
  const {
    icon,
    header,
    link,
    backgroundFill: background,
    textColor: t1,
    handleAnalytics
  } = t0;
  const textColor = t1 === undefined ? "Dark Grey" : t1;
  const Component = link ? Link : "div";
  const t2 = link?.webUrl ?? "";
  let t3;
  if ($[0] !== background) {
    t3 = {
      background
    };
    $[0] = background;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = icon?.webLink;
  const t5 = `${header} icon`;
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = <Image src={t4} alt={t5} />;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== header || $[6] !== textColor) {
    t7 = <Text color={textColor} as="h3">{header}</Text>;
    $[5] = header;
    $[6] = textColor;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== Component || $[9] !== handleAnalytics || $[10] !== t2 || $[11] !== t3 || $[12] !== t6 || $[13] !== t7) {
    t8 = <Component className="nav-card" href={t2} style={t3} onClick={handleAnalytics} prefetch={false}>{t6}{t7}</Component>;
    $[8] = Component;
    $[9] = handleAnalytics;
    $[10] = t2;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}